import axios from 'axios';
import { useState } from 'react';
import { ContentCard } from '../../components/ContentCard/ContentCard';
import { Button } from '../../components/Form/Button';
import { TextInput } from '../../components/Form/TextInput';
import { Icon, close } from '../../components/Icon/Icon';
import { InputGroup } from '../../components/InputGroup/InputGroup';
import { Modal } from '../../components/Modal/Modal';
import { WITH_CREDENTIALS } from '../../components/utils';
import { useConfig } from '../../config';
import { useTranslation } from '../../i18n/i18n';
import './CreateSubscriptionModal.css';
import { InputAlertMessage } from '../Form/InputAlertMessage';

interface CreateSubscriptionModalProps {
	onCreate: () => void;
	subscriptionsCount: number;
}

export const CreateSubscriptionModal = ({
	onCreate,
	subscriptionsCount,
}: CreateSubscriptionModalProps): JSX.Element => {
	const [open, setOpen] = useState(false);
	const [name, setName] = useState('');
	const [valid, setValid] = useState<boolean | null>(null);
	const { api } = useConfig();
	const [loading, setLoading] = useState(false);
	const t = { ...useTranslation().subscriptions, generic: useTranslation().generic, form: useTranslation().form };

	const validate = () => {
		setValid(name !== '');
	};

	const createSubscription = async (name: string): Promise<void> => {
		setLoading(true);

		const payload = { name };

		try {
			await axios.post(`${api}me/lists.json`, payload, WITH_CREDENTIALS);
		} catch (error) {
			console.error(error);
		}

		closeModal();
		setLoading(false);
		onCreate();
	};

	const closeModal = () => {
		setOpen(false);
		setValid(null);
	};

	return (
		<>
			<Button style={{ marginBottom: '1.6rem' }} onClick={() => setOpen(true)}>
				{subscriptionsCount > 0 ? t.createMoreSubscriptions : t.createSubscription}
			</Button>

			<Modal
				className="create-subscription-modal"
				show={open}
				disableBodyScroll
				onDismiss={() => closeModal()}
				toggle={() => setOpen((prev) => !prev)}
			>
				<ContentCard className="create-subscription-content">
					<div className="modal-header">
						<div className="modal-header-title">{t.nameSubscription}</div>
						<button className="close-btn" onClick={() => closeModal()}>
							<Icon shape={{ ...close, fill: 'black' }} size={20} />
						</button>
					</div>
					<div className="modal-body">
						<InputGroup>
							<TextInput
								onBlur={() => {
									validate();
								}}
								placeholder={t.name}
								value={name}
								onChange={(e) => setName(e.target.value)}
							/>
							<Button disabled={loading || !valid} onClick={() => createSubscription(name)}>
								{loading ? t.generic.saving : t.generic.save}
							</Button>
						</InputGroup>
						{valid === false && (
							<InputAlertMessage type={'error'} message={`${t.form.name} ${t.missing}`} />
						)}
					</div>
				</ContentCard>
			</Modal>
		</>
	);
};
